export const raidTypes=[
	{ NAME: 'Select', VALUE: 'magenta' },
	{ NAME: 'RAID 0', VALUE: 'raid0' },
	{ NAME: 'RAID 1', VALUE: 'raid1' },
	{ NAME: 'RAID 5', VALUE: 'raid5' },
	{ NAME: 'RAID 6', VALUE: 'raid6' },
	{ NAME: 'RAID 10', VALUE: 'raid10' },
	{ NAME: 'RAID 50', VALUE: 'raid50' },
	{ NAME: 'RAID 60', VALUE: 'raid60' },
	{ NAME: 'JBOD/JBOF', VALUE: 'jbod' },
	{ NAME: 'Spanning', VALUE: 'spanning' }
  ];

export const getDriveQuantity = ()=>{
	let ret=[]
	for(let i=1;i<13;i++){
		ret.push({NAME:i,VALUE:i})
	}
	return ret
}

export const getDriveSize = ()=>{
	let ret=[{NAME: '1 TB', VALUE: 1},{NAME: '2 TB', VALUE: 2}]
	for(let i=4;i<25;i=i+2){
		ret.push({NAME:i+' TB',VALUE:i})
	}
	return ret
}